export default __webpack_public_path__ + "static/media/zoom.b79769f7.svg";